import { addModuleInStore } from '@/store'
import { Module } from 'vuex'
import state, {
  AddressValidationState as AddressValidationStateType,
  NAMESPACE,
} from './store'

export default function setupStore() {
  const addressValidationStore = state as Module<
    AddressValidationStateType,
    unknown
  >
  addModuleInStore(NAMESPACE, addressValidationStore)
}
